import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';
import { startSessionFlows } from '../utils/sessionFlows';

/**
 * Tracks page views on route changes, and runs the session-flow tracker (utils/sessionFlows.js) for the whole visit.
 * Used once in the main App component.
 */
const usePageTracking = () => {
  const location = useLocation();
  const flows = useRef(null);

  useEffect(() => {
    flows.current = startSessionFlows();
    return () => { flows.current?.stop(); flows.current = null; };
  }, []);

  useEffect(() => {
    flows.current?.navigate();
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);
};

export default usePageTracking;
